import { render, staticRenderFns } from "./LeaderBoardsList.vue?vue&type=template&id=ffd21012&scoped=true"
import script from "./LeaderBoardsList.vue?vue&type=script&lang=js"
export * from "./LeaderBoardsList.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardsList.vue?vue&type=style&index=0&id=ffd21012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd21012",
  null
  
)

export default component.exports